import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { MenuItem, Select, Typography, OutlinedInput } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const styles = {
  fieldCaption: {
    color: 'greys.title',
    fontSize: '1rem',
  },
};

const UserImapBranchSelect = function UserImapBranchSelect({
  handleChangeBranch,
  branches,
}) {
  const intl = useIntl();
  const [value, setValue] = useState(
    sessionStorage.getItem('selectedBranch')
      ? JSON.parse(sessionStorage.getItem('selectedBranch'))?.id
      : branches?.find((x) => x?.isDefault)?.id
  );

  const onChange = (event) => {
    setValue(event.target.value);
    if (event.target.value)
      handleChangeBranch(branches?.find((x) => x?.id === event.target.value));
  };

  return (
    <>
      <Typography variant="subtitle2" sx={styles.fieldCaption}>
        {intl.messages.BRANCH}
      </Typography>
      <Select
        id="branch-select"
        value={value}
        onChange={onChange}
        fullWidth
        IconComponent={KeyboardArrowDownIcon}
        input={<OutlinedInput />}
      >
        {branches.map(({ id, branchDescription }) => (
          <MenuItem key={id} value={id}>
            {branchDescription}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default UserImapBranchSelect;
